<!-- rota: /fatura/serbestfatura/:id  (name: fatura-serbestyeni)                   -->
<!-- rota: /fatura/faturakopya/:id    (name: fatura-serbestyeni, meta: kopya=true) -->
<template>
<div>
    <!-- Yetki cozumu, yetkisiz yonlendirme ve v-app/v-card cercevesi
         sayfataban'da. `baslik` VERILMIYOR: bu ekranin kendi toolbar'i
         (Kaydet / Guncelle / PDF yukle / menu) korunuyor.

         faturakopya adresi (fatura listesindeki kopyalama) bu ekranin KOPYA
         modudur: kaynak fatura islem=get ile okunur, YENI fatura olarak
         kaydedilir (bkz. kopya, faturaGetir). Rota adi ayni oldugu icin yetki
         ayni kayittan cozuluyor. Onceden ayri bir faturakopya.vue vardi; bu
         dosyanin eski bir kopyasiydi. -->
    <sayfataban :oncekiRota="prevRoute" ref="taban">
      <onaydialog ref="onaydialog"></onaydialog>
      <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

      <!-- PDF/OCR yukleme dialoglari: yalnizca bu ekranda var, bilesene tasinmadi. -->
      <!-- Yükleme ilerleme -->
      <v-dialog v-model="ocrProgressDialog" persistent width="420">
      <v-card class="pa-4">
      <div class="mb-2">{{ $t('Processing-File') }}</div>
      <v-progress-linear :indeterminate="ocrBusy" height="6"></v-progress-linear>
      </v-card>
      </v-dialog>
    
      <!-- Kontrol uyarısı -->
      <v-dialog v-model="ocrNoticeDialog" max-width="520">
      <v-card>
      <v-card-title class="headline pb-0">{{ $t('Import_pdf') }}</v-card-title>
      <v-card-text class="pt-3">
      {{ $t('Import_pdf_message') }}
      </v-card-text>
      <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelOcrImport">{{ $t('cancel_button') }}</v-btn>
      <v-btn color="primary" @click="confirmOcrImport">{{ $t('OK') }}</v-btn>
      </v-card-actions>
      </v-card>
      </v-dialog>

      <v-form>
          <v-card color="grey lighten-5">
              <v-layout row wrap>
                  <v-flex xs12 sm12>
                      <v-toolbar size="120px" dark color="info">
                          <v-toolbar-title> {{sayfabaslik}}</v-toolbar-title>
                          <v-spacer></v-spacer>

                          <v-tooltip bottom>
                              <kaydetbutonu data-test="sf-kaydet" v-if="kaydetbuton" slot="activator" :action="Kaydet" :disabled="!sayfayetki.Save" color=""> <span class="hidden-sm-and-down"> {{$t("save_button")}}
                                  </span>
                                  <v-icon right dark>add_box</v-icon>
                              </kaydetbutonu>
                              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                              <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                              <kaydetbutonu data-test="sf-guncelle" v-if="guncellebuton" slot="activator" :action="FaturaGuncelle" :disabled="!sayfayetki.Update || guncelledisabled" color=""> <span class="hidden-sm-and-down"> {{ $t('Update') }}
                                  </span>
                                  <v-icon color="white" right dark>create</v-icon>
                              </kaydetbutonu>
                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                              <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                          </v-tooltip>

                          <kaydetbutonu data-test="sf-yazdir" v-if="yazdirbtngoster" :action="Yazdir" color=""> <span class="hidden-sm-and-down"> {{ $t('Print') }} </span>
                              <v-icon right dark>print</v-icon>

                          </kaydetbutonu>
                          <!-- OCR butonu + gizli dosya inputu. Kopya modunda yok (eski faturakopya
                               ekraninda da yoktu; kopyalanan faturanin uzerine yazardi). -->
  <v-btn v-if="!kopya" flat @click="openOcr">
    <span class="hidden-sm-and-down">{{ $t('Import_pdf') }}</span>
    <v-icon right dark>file_upload</v-icon>
  </v-btn>
  <input ref="ocrFile" type="file" accept=".pdf,.png,.jpg,.jpeg" style="display:none" @change="handleOcrFile">


                          <v-menu offset-y>
                              <v-btn data-test="sf-menu" slot="activator" dark icon>
                                  <v-icon>more_vert</v-icon>
                              </v-btn>
                              <v-list>

                                  <v-tooltip bottom>
                                      <v-list-tile data-test="sf-fatura-sil" v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Delete" @click="faturasilsor()">
                                          <v-list-tile-title> {{ $t('Delete-Invoice') }} </v-list-tile-title>
                                      </v-list-tile>
                                      <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                                      <span v-if="sayfayetki.Delete"> {{ $t('Delete-Invoice') }} </span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                      <v-list-tile data-test="sf-no-degistir" v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Update || guncelledisabled" @click="faturanotarihdegistir(0)">
                                          <v-list-tile-title> {{ $t('Change-Invoice-Number') }} </v-list-tile-title>
                                      </v-list-tile>
                                      <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                      <span v-if="sayfayetki.Update"> {{ $t('Change-Invoice-Number') }} </span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                      <v-list-tile data-test="sf-tarih-degistir" v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Update || guncelledisabled" @click="faturanotarihdegistir(1)">
                                          <v-list-tile-title> {{ $t('Change-Invoice-Date') }} </v-list-tile-title>
                                      </v-list-tile>
                                      <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                      <span v-if="sayfayetki.Update"> {{ $t('Change-Invoice-Date') }} </span>
                                  </v-tooltip>

                                  <a target="_self" v-bind:href="'#/faturalar/faturalistesi'">
                                      <v-list-tile>
                                          <v-list-tile-title> {{ $t('Leave') }} </v-list-tile-title>
                                      </v-list-tile>
                                  </a>
                              </v-list>
                          </v-menu>
                      </v-toolbar>
                  </v-flex>

                  <!-- Fatura govdesi (header + satir girisi + liste + dip toplamlar)
                       fatura/faturakalemleri.vue bileseninde. -->
                  <faturakalemleri
                    ref="kalemler"
                    :fatura="SerbestFatura"
                    v-model="satiritems"
                    :duzenlenebilir="sayfayetki.Update"
                    :sayfayetki="sayfayetki"
                    :guncellebuton="guncellebuton"
                    :yazdirbtngoster="yazdirbtngoster"
                    :yukleniyor="loadingdialog"
                    :faturasilonayi.sync="dialogsor"
                    @degisti="faturatoplambul"
                    :faturasilislemi="faturasil"
                    @hata="kalemHatasi"
                    @faturatipisecildi="iadeUyarisi" />

              </v-layout>
          </v-card>
      </v-form>

      <v-dialog v-model="iadedialog" scrollable="" persistent="" max-width="350px">
          <v-card flat color="grey lighten-5">
              <v-card-title> {{ $t('Required-Fields-for-Return-Invoice') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                  <v-layout row wrap="">

                      <v-flex xs12 sm12 md12>
                          <v-form ref="formiade" v-model="iadevalid" lazy-validation>
                              <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                      <tarihcomp data-test="sf-iade-tarih" :etiket="$t('Invoice-Date-Referring-To')" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:value="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi" v-model="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi"></tarihcomp>
                                  </v-flex>
                                  <v-flex xs12 sm6 md6>
                                      <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaSeri" :label="$t('Serial')" data-test="sf-iade-seri">
                                      </v-text-field>

                                  </v-flex>

                                  <v-flex xs12 sm6 md6>
                                      <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaNo"  :label="$t('No')" data-test="sf-iade-no">
                                      </v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                      <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="SerbestFatura.IadeFaturaBilgi.IadeNedeni" maxlength="99" :label="$t('Cause')" data-test="sf-iade-nedeni">
                                      </v-text-field>

                                  </v-flex>

                              </v-layout>
                          </v-form>
                      </v-flex>

                  </v-layout>

              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click.native="iadedialog=false">{{$t("cancel_button")}}</v-btn>
                  <kaydetbutonu data-test="sf-iade-guncelle" color="blue darken-1" v-if="guncellebuton" :action="iadeFaturaKayit">{{ $t('Update') }}</kaydetbutonu>
                  <kaydetbutonu data-test="sf-iade-kaydet" color="blue darken-1" v-if="kaydetbuton" :action="iadeFaturaKayit">{{$t("save_button")}}</kaydetbutonu>

              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog v-model="dialogdegistir" scrollable="" persistent="" max-width="400px">
          <v-card color="grey lighten-5">
              <v-card-title> {{ $t('Change-Invoice-Details') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                  <v-flex ma-1 xs12 sm12 md12>
                      <v-card class="white--text">
                          <v-card flat="">
                              <v-card-actions>

                                  <v-flex xs12 sm12 md12>
                                      <div v-if="islemturu==1">
                                          <tarihcomp data-test="sf-degistir-tarih" :etiket="$t('Date')" v-bind:value="ChangeTarih" v-model="ChangeTarih"></tarihcomp>
                                      </div>
                                      <div v-if="islemturu==0">
                                          <v-layout>
                                              <v-flex xs12 sm12 md12>
                                                  <v-text-field data-test="sf-degistir-no" hide-details="" type="number" :label="$t('Invoice-Number-v2')" v-model="ChangeFaturaNo">
                                                  </v-text-field>
                                              </v-flex>
                                          </v-layout>
                                      </div>
                                  </v-flex>
                              </v-card-actions>
                          </v-card>
                      </v-card>
                  </v-flex>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn data-test="sf-degistir-iptal" color="blue darken-1" flat @click.native="dialogdegistir=false">{{$t("cancel_button")}}</v-btn>
                  <kaydetbutonu data-test="sf-degistir" color="blue darken-1" :action="faturabilgidegistir">{{ $t('Change') }}</kaydetbutonu>
              </v-card-actions>
          </v-card>
      </v-dialog>



    </sayfataban>
</div>
</template>

<script>
import tool from '@/components/app/coper/tools.js'
import faturaIslemleri from './faturaIslemleri.js'
import faturakalemleri from './faturakalemleri.vue'
import tarihcomp from '../customcomp/tarihim'
import helpers from "@/components/app/customcomp/helpers.js"
import sayfataban from "@/components/app/customcomp/sayfataban.vue"
import onaydialog from "@/components/app/customcomp/onaydialog.vue"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue";

// Kaydet, guncelle, iade kaydi, no/tarih degistirme ve silme faturaIslemleri.js'de.
const islemler = faturaIslemleri.metotlar()

// ---------- Helpers ----------
function ocrFirstNonEmpty() {
  for (var i = 0; i < arguments.length; i++) {
    var v = arguments[i];
    if (v !== undefined && v !== null && String(v).trim() !== '') return v;
  }
  return null;
}
function ocrParseDecimal(v) {
  if (v === undefined || v === null) return 0;
  var s = String(v).trim();
  var useCommaAsDecimal = s.lastIndexOf(',') > s.lastIndexOf('.');
  var n = useCommaAsDecimal ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
  var d = parseFloat(n);
  return isNaN(d) ? 0 : d;
}
function ocrMoneyOrNull(v) {
  if (v === undefined || v === null) return null;
  var d = ocrParseDecimal(v);
  return isNaN(d) ? null : +d.toFixed(2);
}
function ocrTo2(v) { return +ocrParseDecimal(v).toFixed(2); }

function ocrParseDateToIso(s) {
  if (!s) return null;
  s = String(s).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  var m = s.match(/(\d{1,4})[\.\/\-](\d{1,2})[\.\/\-](\d{1,4})/);
  if (m) {
    var a = [m[1], m[2], m[3]], y, M, d;
    if (a[0].length === 4) { y = +a[0]; M = +a[1]; d = +a[2]; }
    else if (a[2].length === 4) { d = +a[0]; M = +a[1]; y = +a[2]; }
    else { d = +a[0]; M = +a[1]; y = 2000 + (+a[2]); }
    var mm = (M < 10 ? '0'+M : ''+M);
    var dd = (d < 10 ? '0'+d : ''+d);
    return y + '-' + mm + '-' + dd;
  }
  var d2 = new Date(s);
  if (isNaN(d2.getTime())) return null;
  var mm2=('0'+(d2.getMonth()+1)).slice(-2), dd2=('0'+d2.getDate()).slice(-2);
  return d2.getFullYear() + '-' + mm2 + '-' + dd2;
}

// yalnız KDV yüzdesi için: 20.00 -> 20
function ocrPercentInt(v) {
  var d = ocrParseDecimal(v);
  return isNaN(d) ? 0 : Math.trunc(d);
}

// açıklamadan % yakala (yedek)
function ocrTryExtractVatPercent(desc) {
  if (!desc) return null;
  var m = String(desc).match(/(?:%?\s*)(?:vat|tva|kdv|moms)?\s*[:%]?\s*(\d{1,2}(?:[.,]\d{1,2})?)\s*%?/i);
  return m ? ocrParseDecimal(m[1]) : null;
}

// ---------- Mapper ----------
function mapOcrToSerbestFatura(ocr, mevcutModel) {
  var f = JSON.parse(JSON.stringify(mevcutModel || {}));
  var fld = (ocr && ocr.fields) || {};
  var cur = ((fld.currency || '') + '').toUpperCase();

  // Üst alanlar
  f.FaturaSeri = f.FaturaSeri || (fld.serial_number || '');
  f.FaturaNo   = ocrFirstNonEmpty(fld.document_number, f.FaturaNo) || '';

  var issueIso = ocrParseDateToIso(fld.issue_date);
  var dueIso   = ocrParseDateToIso(fld.due_date);
  f.Tarih = issueIso || f.Tarih || null;
  f.Vade  = dueIso   || f.Tarih || null;

  f.Referans = f.Referans || { Kod: '' };
  f.Referans.Kod = ocrFirstNonEmpty(fld.reference_code, f.Referans.Kod) || '';

  f.Doviz = f.Doviz || { DovizKod: '' };
  f.Doviz.DovizKod = cur || (f.Doviz.DovizKod || 'TRY');
  f.Dovizli = cur && cur !== 'TRY' ? true : false;
  f.Kur = ocrTo2(ocrFirstNonEmpty(fld.exchange_rate, f.Kur));

  f.Aciklama = ocrFirstNonEmpty(fld.notes, f.Aciklama) || '';

  // Özetler (varsa)
  f.Tutarlar = f.Tutarlar || { ToplamTutar: 0, Iskonto: 0, FaturaToplam: 0, Kdv: 0, TevkifatKdv: 0 };
  var subtotal = ocrMoneyOrNull(fld.subtotal);
  var grand    = ocrMoneyOrNull(fld.grand_total);
  var taxtotal = ocrMoneyOrNull(fld.tax_total);
  if (subtotal != null) f.Tutarlar.ToplamTutar = subtotal;
  if (grand    != null) f.Tutarlar.FaturaToplam = grand;
  if (taxtotal != null) f.Tutarlar.Kdv         = taxtotal;

  // Satırlar
  f.SerbestFaturaDetay = [];
  var lines = Array.isArray(ocr && ocr.lines) ? ocr.lines : [];

  for (var i = 0; i < lines.length; i++) {
    var ln = lines[i] || {};
    var desc = (ln.description || '').trim();
    if (!desc) continue;

    // Tutar (öncelik: unit -> net -> line_total/(1+%kdv))
    var amountFromUnit = ocrParseDecimal(ln.unit);
    var netFromJson    = ocrParseDecimal(ln.net);
    var totFromJson    = ocrParseDecimal(ln.line_total);

    var kdvPctCandidate = (ln.tax_rate != null) ? ocrParseDecimal(ln.tax_rate) : ocrTryExtractVatPercent(desc);
    var kdvYuzde = ocrPercentInt(kdvPctCandidate); // 20.00 -> 20

    var net = 0;
    if (amountFromUnit)       net = amountFromUnit;
    else if (netFromJson)     net = netFromJson;
    else if (totFromJson && kdvYuzde) net = +(totFromJson / (1 + (kdvYuzde / 100))).toFixed(2);

    // KDV Tutar = Tutar × (KDV%/100)
    var kdvTutar = (kdvYuzde > 0 && net > 0) ? +(net * (kdvYuzde / 100)).toFixed(2) : 0;

    f.SerbestFaturaDetay.push({
      MuhasebeKodu: '',
      Aciklama: desc,
      LineNote: '',
      Referans: { Kod: (f.Referans && f.Referans.Kod) || '' },
      Masraf:   { Code: (f.Masraf && f.Masraf.Code) || '' },

      Miktar: 1,
      Birim:  '',
      BirimFiyat: 0,

      // MAL HİZMET TUTARI (unit’ten)
      Tutar: ocrTo2(net),
      DovizTutar: (f.Dovizli && f.Kur > 0) ? ocrTo2(net / f.Kur) : ocrTo2(net),

      IskontoYuzde: 0,
      IskontoTutar: 0,

      // KDV (yüzde ve tutar doldurulsun)
      KdvTip: 'D',                 // burada biz hesaplayıp yazıyoruz
      KdvYuzde: kdvYuzde,          // tam sayı (ör: 20)
      KdvTutar: ocrTo2(kdvTutar),  // net * %kdv

      KdvMuhKodu: '', IskMuhKodu: '', KdvKodu: '',
      IstisnaKodu: '', TevkifatKodu: '', Tip: '',
      TevkifatDetayTutar: 0, TevkifatDetayOran: 0,
      TeslimBilgileri: {
        SokakAdi:'',BinaAdi:'',BinaNo:'',TeslimSehir:'',TeslimPostaKodu:'',
        TeslimUlke:'',TeslimSarti:'',GTIPNo:'',TransferKodu:'',
        KabinNo:'',KabinAdedi:'',KabinCinsi:'',TeslimOdeme:''
      }
    });
  }

  // hiç satır yoksa emniyet satırı
  if (f.SerbestFaturaDetay.length === 0) {
    f.SerbestFaturaDetay.push({
      MuhasebeKodu:'', Aciklama:f.Aciklama || '', LineNote:'',
      Referans:{Kod: (f.Referans && f.Referans.Kod) || ''},
      Masraf:{Code: (f.Masraf && f.Masraf.Code) || ''},
      Miktar:1, Birim:'', BirimFiyat:0,
      Tutar:0, DovizTutar:0,
      IskontoYuzde:0, IskontoTutar:0,
      KdvTip:'D', KdvYuzde:0, KdvTutar:0,
      KdvMuhKodu:'', IskMuhKodu:'', KdvKodu:'',
      IstisnaKodu:'', TevkifatKodu:'', Tip:'',
      TevkifatDetayTutar:0, TevkifatDetayOran:0,
      TeslimBilgileri:{
        SokakAdi:'',BinaAdi:'',BinaNo:'',TeslimSehir:'',TeslimPostaKodu:'',
        TeslimUlke:'',TeslimSarti:'',GTIPNo:'',TransferKodu:'',
        KabinNo:'',KabinAdedi:'',KabinCinsi:'',TeslimOdeme:''
      }
    });
  }

  // özetleri boşsa görünüm için Net topla
  var sumNet = 0, sumTax = 0;
  for (var j = 0; j < f.SerbestFaturaDetay.length; j++) {
    sumNet += ocrParseDecimal(f.SerbestFaturaDetay[j].Tutar);
    sumTax += ocrParseDecimal(f.SerbestFaturaDetay[j].KdvTutar);
  }
  if (!f.Tutarlar.ToplamTutar)  f.Tutarlar.ToplamTutar = +sumNet.toFixed(2);
  if (!f.Tutarlar.Kdv)          f.Tutarlar.Kdv         = +sumTax.toFixed(2);
  if (!f.Tutarlar.FaturaToplam) f.Tutarlar.FaturaToplam= +(sumNet + sumTax).toFixed(2);

  f.Serbest = (typeof f.Serbest === 'boolean') ? f.Serbest : true;
  f.AlisSatis = false;
  return f;
}







export default {
    data() {
        return {
            ocrBusy: false,
            ocrProgressDialog: false,
            ocrNoticeDialog: false,
            ocrDraft: null,
            lastOcrJson: null,
            guncelledisabled: false,
            iadevalid: true,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },

            yazdirbtngoster: false,
            dialogsor: false,
            nefaturasi: 'serbest',

            SerbestFatura: {
                SirketKodu: '',
                SerbestFaturaDetay: [],
                Serbest: true,
                AlisSatis: false,
                FaturaSeri: '',
                FaturaNo: '',
                Update: false,
                Dovizli: false,
                FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
                Evrak: {
                    Evrakkod: ''
                },
                Cari: {
                    Kod: ''
                },
                EFaturaBilgi: {
                    Unvani: '',
                    Unvani2: '',
                    Adres1: '',
                    Adres2: '',
                    IlceSehir: '',
                    Email: '',
                    VergiDairesi: '',
                    VergiNo: '',
                    TcKimlikNo: '',
                    Adi: '',
                    Soyadi: '',
                    TUnvani: '',
                    DigerAdi: '',
                    OnAdiEki: '',
                },
                Tarih: null,
                GibSeri: '',
                Vade: null,
                Referans: {
                    Kod: ''
                },
                Masraf: {
                    Code: ''
                },
                Aciklama: '',
                Doviz: {
                    DovizKod: ''
                },
                FTimeStamp:null,
                FaturaUnique:null,
                Kur: 0,
                TevkivatKdv: 0,
                FaturaID: 0,
                CariAktarma: false,
                Tutarlar: {
                    ToplamTutar: 0,
                    Iskonto: 0,
                    FaturaToplam: 0,
                    Kdv: 0,
                    TevkifatKdv: 0
                },
                Efaturakayit: false,
                Earchiveakayit: false,
                Kagitfatura: false,
                EarsivBilgi: {
                    GonderimSekli: '',
                    InternetSatis: '',
                    pWebAdresi: '',
                    OdemeSekli: '',
                    OdemeSekliAciklama: '',
                    OdemeAraci: '',
                    OdemeTarihi: ''
                },
                EFaturaShowID: {
                    EFaturaID: null,
                    EFaturaGuid: null,
                    FaturaStatus: null,
                    PdfID: null,
                    DizaynID: null,
                    XsltID: null

                },
                IadeFaturaBilgi: {
                    IadeNedeni: null,
                    IstinadenFaturaSeri: null,
                    IstinadenFaturaNo: null,
                    IstinadenFaturaTarihi: null
                }
            },
            iadedialog: false,
            satiritems: [],
            dictionary: {
                custom: {
                    carikod: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    unvan: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    faturaseri: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    faturano: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },

                    dizayn: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    xslt: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    gtip: {
                        min: () => this.$t('Must-least-4-digits'),
                    }

                }
            },
            sayfabaslik: this.$t('Free-Invoice'),
            kaydetbuton: true,
            guncellebuton: false,
            text1: '',
            loadingdialog: false,
            snackbar: false,
            islemturu: null,
            dialogdegistir: false,
            ChangeTarih: null,
            ChangeFaturaNo: null,
            /** beforeRouteEnter dolduruyor; sayfataban'a prop olarak gidiyor.
             *  data'da TANIMLI olmali, yoksa tepkisel degil ve prop guncellenmez. */
            prevRoute: null,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    computed: {
        /**
         * faturakopya rotasi (router.js meta.kopya): kaynak fatura okunur, Kaydet onu YENI
         * fatura olarak kaydeder. Guncelle / sil / no-tarih degistirme yok.
         */
        kopya() {
            return this.$route.meta.kopya === true
        },
    },
    mounted() {
        this.$validator.localize('en', this.dictionary)

        // Yetki cozumu ve yetkisiz yonlendirme sayfataban'da; taban ic ice
        // bir bilesen oldugu icin kendi mounted'i BURADAN ONCE calisir.
        this.sayfayetki = this.$refs.taban.sayfayetki
        if (this.sayfayetki.Status == true) {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var params1 = {
                CompanyCode: credentials.SirketKodu,
            }
            var islem = this.$route.query.islem

            if (islem == "yeni" || islem == "get") {
                this.nefaturasi = 'serbest'
            }

            if (islem == "yenigelenevrak" || islem == "gelenevrak") {
                this.yazdirbtngoster = false
                this.nefaturasi = 'gelen'
                this.SerbestFatura.GibSeri = null;
                this.sayfabaslik =  this.$t('Invoice-Received');
                this.SerbestFatura.CariAktarma = false;
            }

            // Listeler ve rota bazli fatura tipi/dizayn ayarlari bilesende.
            // Yetki kontrolunun ICINDEN cagriliyor ki sira degismesin.
            this.$refs.kalemler.baslangicYukle(params1);

            if (this.kopya) {
                // Kopya islem=get ile acilir ama Kaydet YENI kayit yapar: bilesen get'te
                // seri/no'yu kilitliyor, kopyada duzenlenebilir kalmali.
                this.$refs.kalemler.seridisable = false
                if (islem == "get") {
                    this.faturaGetir()
                }
            } else if (islem == "get" || islem == "gelenevrak") {
                this.kayitliModaGec()
            }

        }

    },

    methods: {
        openOcr() { if (this.$refs.ocrFile) this.$refs.ocrFile.click(); },

  handleOcrFile(e) {
    const file = e && e.target && e.target.files && e.target.files[0];
    if (!file) return;

    const fd = new FormData();
    fd.append('file', file);

    this.ocrBusy = true;
    this.ocrProgressDialog = true;

    const self = this;
    tool.api_post(this, 'ocr/to-json?engine=auto', fd).then(function(res){
      self.lastOcrJson = res.body;
      // taslak modeli hazırla (kullanıcı onaylayınca forma yazacağız)
      self.ocrDraft = mapOcrToSerbestFatura(res.body, self.SerbestFatura);
      // progress kapat, uyarıyı göster
      self.ocrProgressDialog = false;
      self.ocrNoticeDialog = true;
      if (e && e.target) e.target.value = '';
    }).catch(function(err){
      console.error('OCR Hatası:', err);
      self.ocrProgressDialog = false;
      // Istek hatasinda sunucunun gercek aciklamasi (CLAUDE.md: HataMesajiCoz); yanit
      // donusturulurken cikan bir JS hatasinin da kendi mesaji gosterilir.
      self.text1 = err && err.status !== undefined
        ? tool.HataMesajiCoz(err, self.$t.bind(self))
        : String((err && err.message) || err);
      self.snackbar = true;
      if (e && e.target) e.target.value = '';
    }).finally(function(){
      self.ocrBusy = false;
    });
  },

  cancelOcrImport(){
    this.ocrNoticeDialog = false;
    this.ocrDraft = null;
  },
  confirmOcrImport(){
    if (!this.ocrDraft) { this.ocrNoticeDialog = false; return; }
    this.SerbestFatura = this.ocrDraft;
    this.satiritems = Array.isArray(this.SerbestFatura.SerbestFaturaDetay)
      ? this.SerbestFatura.SerbestFaturaDetay : [];
    this.faturatoplambul();
    this.ocrNoticeDialog = false;
  },
  
        /**
         * Zorunlu alanlarin bir kismi (faturaseri / faturano / dizayn)
         * faturakalemleri bileseninde. vee-validate her bilesene AYRI
         * dogrulayici kuruyor; sayfanin kendi validateAll'i o alanlari
         * gormedigi icin bos formda bile true donuyordu. Ikisi birlikte
         * calistirilmali.
         */
        tumAlanlariDogrula() {
            var bilesen = this.$refs.kalemler
                ? this.$refs.kalemler.$validator.validateAll()
                : Promise.resolve(true);
            return Promise.all([this.$validator.validateAll(), bilesen])
                .then(function (r) { return r[0] && r[1]; });
        },
          /** faturakalemleri bilesenden gelen mesaji sayfanin snackbar'inda gosterir. */
          kalemHatasi(mesaj) {
              this.text1 = mesaj;
              this.snackbar = true;
          },

          /**
           * Fatura toplamlari. Hesabi BILESEN yapiyor (toplamlariYenile ->
           * faturaHesap.faturaToplamlari): tek yuvarlama kurali, tek kod.
           *
           * Onceden bu metot ayni hesabi KENDI kopyasiyla yapiyordu ve
           * bilesenin yazdigi toplamlarin uzerine yaziyordu -- kendi
           * yuvarlamasiyla (Math.round, negatiflerde SQL ROUND'dan sapar).
           */
          faturatoplambul() {
              if (this.$refs.kalemler) this.$refs.kalemler.toplamlariYenile();
          },

        faturanotarihdegistir(tur) {
            //tur 0 ise faturatarih 1 ise tarih

            this.dialogdegistir = true;
            if (tur == 0) {
                this.islemturu = 0;
                this.ChangeFaturaNo = this.SerbestFatura.FaturaNo
                this.ChangeTarih = null
            } else if (tur == 1) {
                this.ChangeTarih = this.SerbestFatura.Tarih
                this.ChangeFaturaNo = null
                this.islemturu = 1;
            }

        },
        /**
         * Yazdir (kaydetbutonu). Dizaynin PDF sablonu dizayn listesinden bulunur (faturakalemleri
         * dizaynbilgigetir). Sablon yoksa (null ya da 0) yazdirilmaz, kullanici uyarilir; onceden
         * yalnizca 0 denetleniyordu, dizayn listede bulunamayinca null sablonla yazdirilmaya
         * calisiliyordu. Buton yazdirma bitene kadar pasif kalsin diye istegin Promise'i dondurulur.
         */
        Yazdir() {
            this.$refs.kalemler.dizaynbilgigetir(this.SerbestFatura.EFaturaShowID.DizaynID);

            var pdfId = this.SerbestFatura.EFaturaShowID.PdfID
            if (!(parseInt(pdfId, 10) > 0)) {
                this.text1 = this.$t('design-you-selected-does-include-invoice-present-design-Invoice-screen')
                this.snackbar = true
                return
            }

            var prm = {
                id: this.SerbestFatura.EFaturaShowID.EFaturaID,
                guid: this.SerbestFatura.EFaturaShowID.EFaturaGuid
            };
            return this.$refs.kalemler.reportbroYazdir(prm, pdfId).then((sonuc) => {
                if (sonuc.sonuc != true) {
                    this.text1 = sonuc.mesaj
                    this.snackbar = true
                }
            });
        },
        faturasilsor() {
            this.dialogsor = true;
        },
        /**
         * Kullanici fatura tipini Iade secince (faturakalemleri'nin faturatipisecildi olayi) iade
         * bilgilerinin kayit / guncellemede istenecegi bildirilir. Onceden SerbestFatura.FaturaTip
         * izleyicisindeydi ve kayitli iade faturasi YUKLENIRKEN de aciliyordu; v-autocomplete'in
         * change olayi yalnizca kullanici seciminde gelir.
         */
        iadeUyarisi(tip) {
            if (tip == 1) {
                this.$refs.onaydialog.open(
                    this.$t('Details-regarding-return-invoice-will-entered-after-save-update-process'), 2)
            }
        },
        /**
         * Kayitli fatura modu: Guncelle, silme ve no/tarih degistirme acik, Kaydet kapali, seri/no
         * kilitli; fatura adresteki bilgilerle okunur. Acilista (islem=get / gelenevrak) ve
         * kayittan sonra cagrilir (faturaIslemleri kayitliFaturayiAc adresi degistirir, sayfa
         * yeniden yuklenmez). Serbest faturada Yazdir acilir; caricomp da bununla kilitlenir.
         * Kopya acilista bu moda gecmez: Yazdir kapali kalir, cari degistirilebilir.
         */
        kayitliModaGec() {
            this.guncellebuton = true
            this.kaydetbuton = false
            this.yazdirbtngoster = this.nefaturasi == 'serbest'
            this.$refs.kalemler.seridisable = true
            return this.faturaGetir()
        },
        Kaydet: islemler.Kaydet,
        FaturaGuncelle: islemler.FaturaGuncelle,
        faturasil: islemler.faturasil,
        iadeFaturaKayit: islemler.iadeFaturaKayit,
        faturabilgidegistir: islemler.faturabilgidegistir,
        faturaGetir: faturaGetir
    },
    components: {
        faturakalemleri,
        kaydetbutonu,
        'tarihcomp': tarihcomp,
        sayfataban,
        onaydialog,
        snackbarcomp
    },
    watch: {
        'SerbestFatura.FaturaNo': function (v) {
            // Fatura no 0 ile baslayamaz. Alan v-model.number oldugu icin deger sayi da geliyor;
            // kopya modu ve bos form null / '' veriyor. Onceden `v.length` null'da hata
            // firlatiyor, sayida hic calismiyor, "0"da alani [] (dizi) yapiyordu.
            if (v !== null && v !== undefined && String(v) === '0') {
                this.SerbestFatura.FaturaNo = ''
            }
        },
    }
}

/**
 * Faturayi adresteki bilgilerle (ft, ck, es, en, ner, sb) okur; istegin Promise'ini dondurur.
 * Kopya modunda kaynak faturanin kimligi, seri / numarasi ve GiB serisi bosaltilir, tarih ve
 * vade bugun olur: Kaydet YENI fatura olarak kaydeder (Update=false, FaturaUnique bos); yoksa
 * kaynak fatura ezilirdi.
 */
function faturaGetir() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params2 = {
        SirketKodu: credentials.SirketKodu,
        Tarih: this.$route.query.ft,
        CariKod: this.$route.query.ck,
        EvrakTipi: '',
        EvrakSeri: this.$route.query.es,
        Evrakno: this.$route.query.en,
        Nereden: this.$route.query.ner,
        Serbest: this.$route.query.sb,
    }

    this.loadingdialog = true

    return tool.api_post(this, 'Invoice/FreeInvoiceGet', params2).then((response) => {

        if (response.body.EFaturaBilgi == null) {
            response.body.EFaturaBilgi = {
                Unvani: '',
                Unvani2: '',
                Adres1: '',
                Adres2: '',
                IlceSehir: '',
                Email: '',
                VergiDairesi: '',
                VergiNo: '',
                TcKimlikNo: '',
                Adi: '',
                Soyadi: '',
                TUnvani: '',
                DigerAdi: '',
                OnAdiEki: '',
            }
        }
        this.SerbestFatura = response.body

        if (this.kopya) {
            // Cari kaynaktan kalir: caricomp bilgisini sunucudan tazeler (e-fatura bilgisi,
            // gonderim sekli, GiB serisi listesi). Tarih ve vade bugun; cari bilgisi gelince vade
            // carinin vade gunune gore yeniden hesaplanir (faturakalemleri cariBilgisiGeldi).
            // Onceden cari ve tarih bosaltiliyor, kaynagin vadesi kaliyordu.
            var bugun = helpers.bugunIso()
            this.SerbestFatura.Tarih = bugun
            this.SerbestFatura.Vade = bugun
            this.SerbestFatura.FaturaSeri = null
            this.SerbestFatura.FaturaNo = null
            this.SerbestFatura.GibSeri = null
            this.SerbestFatura.FaturaID = 0
            this.SerbestFatura.FaturaUnique = null
            this.SerbestFatura.Update = false
            this.SerbestFatura.Serbest = true
            this.SerbestFatura.FTimeStamp = null
            // Kaynak gelen e-faturadan aktarildiysa ETTN'i kopyaya gecmesin: API ayni e-faturanin
            // baska cariye aktarilip aktarilmadigina once ETTN ile bakiyor. Model Guid (null kabul etmez).
            this.SerbestFatura.ETTN = '00000000-0000-0000-0000-000000000000'
        }

        if (response.body.EFaturaShowID != null) {
            if (response.body.EFaturaShowID.FaturaStatus != 'Fatura Beklemede' && this.$route.query.islem ==
                "get") {
                this.guncelledisabled = true
            } else {
                this.guncelledisabled = false
            }
        }

        this.satiritems = response.body.Detay
        this.loadingdialog = false

    }, (response) => {
        // Sunucunun gercek aciklamasi (duz metin govde, 429 sinirlama mesaji vb.).
        this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
        this.snackbar = true
        this.loadingdialog = false
    })
}
</script>
